import React from 'react';

import HandyPageWrapper from '~Scenes/Handy/Components/HandyPageWrapper';
import PaymentsSettings from '~Scenes/Settings-v2/Scenes/Payments';
import { useI18n } from '~Hooks';

/** Handheld shell around the shared Settings-v2 payments scene */
const HandyPayments = () => {
  const { i18n } = useI18n();

  return (
    <HandyPageWrapper pageTitle={i18n('Handy.Settings.PaymentsTitle')}>
      <PaymentsSettings isHandy />
    </HandyPageWrapper>
  );
};

export default HandyPayments;
